import type { FilterAxis } from '../results/filter_logic.js';
import type { FlightFilterCopy } from '../results/filters/filter_copy.js';
import type { FlightExplorerPageCopy } from './explorer_copy.js';

/** O rótulo de cada eixo é o MESMO do painel — a dica aponta para o bloco que a
 *  pessoa vai abrir, sem inventar um segundo nome para a mesma coisa. */
function axisLabel(axis: FilterAxis, page: FlightExplorerPageCopy, filter: FlightFilterCopy) {
  const labels: Record<FilterAxis, string> = {
    stops: filter.stops.label,
    airlines: filter.airline,
    airports: filter.airports.label,
    time: filter.time.label,
    policy: filter.policy.label,
    price: filter.price.label,
    flightNumber: filter.flightNumber.label,
    connections: page.axisVia,
  };
  return labels[axis];
}

/**
 * A dica do vazio-por-filtro nomeia os eixos que ESTÃO cortando (#3239 C5):
 * "Tente afrouxar política ou número do voo", e não a lista fixa "paradas,
 * horário ou preço" de quando só esses três existiam. O host junta os nomes na
 * disjunção do idioma (`emptyHintAxes`). Sem eixo ativo (a lista zerou por outro
 * motivo) cai na frase genérica, como antes.
 */
export function filterEmptyHint(
  axes: readonly FilterAxis[],
  page: FlightExplorerPageCopy,
  filter: FlightFilterCopy,
): string {
  if (axes.length === 0) return page.emptyHint;
  return page.emptyHintAxes(axes.map((axis) => axisLabel(axis, page, filter)));
}
